export default "__VITE_ASSET__CPHCB5J7__"